module.exports = __webpack_public_path__ + "img/customer_first_menu_2.19ac7fbc.png";